const c_name = "OneboardShown"

export class Cookies {
    GetOneboardKey(): string {

        if (document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return decodeURI(document.cookie.substring(c_start, c_end));
            }
            else return "true"
        }
        return "true";
    }

    SetOneboardKey(value: boolean): void {
        let updatedCookie = c_name + "=" + value + ";" + "max-age=10000000;"
        document.cookie = updatedCookie;
    }
}

export default Cookies;